// 画面で起きた例外をサーバーへ送る（クローズドβの不具合調査用）。同じ内容は1回だけ、1回の起動で20件まで。
// 直近の例外はチャットの「報告」にも添える（recentErrors）。
type Recorded = { message: string; screen: string; at: number };

const MAX_SEND = 20;
const recent: Recorded[] = [];
const sent = new Set<string>();

/** 読み込んだ画面のファイル名（ビルドごとに変わる）。どの版で起きたかの目印 */
export const buildId = () => new URL(import.meta.url).pathname.split('/').pop() ?? '';

export const recentErrors = () => recent.slice(-5);

function record(message: string, stack?: string) {
  message = message.slice(0, 500);
  const screen = location.hash.slice(0, 200);
  recent.push({ message, screen, at: Date.now() });
  if (recent.length > 10) recent.shift();
  if (sent.has(message) || sent.size >= MAX_SEND) return;
  sent.add(message);
  void fetch('/api/client-errors', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ message, stack: stack?.slice(0, 2000), screen, build: buildId() }),
    keepalive: true,
  }).catch(() => {});
}

window.addEventListener('error', (e) => {
  // 別オリジンのスクリプト（Google ログインなど）の中身の見えない例外は送らない
  if (!e.error && /^Script error\.?$/.test(e.message)) return;
  record(e.message || String(e.error), e.error instanceof Error ? e.error.stack : undefined);
});

window.addEventListener('unhandledrejection', (e) => {
  const r = e.reason as { status?: unknown; name?: unknown } | undefined;
  // API の失敗（ApiError）はサーバー側で分かるので送らない
  if (r && typeof r === 'object' && typeof r.status === 'number') return;
  if (r instanceof Error) record(`${r.name}: ${r.message}`, r.stack);
  else record(`unhandledrejection: ${String(r)}`);
});
